import React from 'react';
import ServiceSubTitle from './ServiceSubTitle';
import './ServiceList.less';

function ServiceList({data}) {
  const renderItem = ({title, description}, index) => {
    return (
      <div key={index}>
        <ServiceSubTitle>{title}</ServiceSubTitle>
        <p>{description}</p>
      </div>
    );
  };
  return (
    <div className='ServiceList'>
      {data.map(renderItem)}
    </div>
  );
}

export default ServiceList;


// WEBPACK FOOTER //
// ./src/routes/Service/ServiceList.js